import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixReceiptsSettingsV1ReceiptsSettingsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/receipts-settings',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/receipts/v1/receipts-settings',
        destPath: '/v1/receipts-settings',
      },
    ],
    _: [
      {
        srcPath: '/receipts/v1/receipts-settings',
        destPath: '/v1/receipts-settings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/receipts/v1/receipts-settings',
        destPath: '/v1/receipts-settings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_get-paid_receipts-settings';

/** Retrieves a site's receipt settings. */
export function getReceiptsSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __getReceiptsSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.receipts.v1.receipts_settings',
      method: 'GET' as any,
      methodFqn:
        'wix.receipts.settings.v1.ReceiptsSettingsService.GetReceiptsSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixReceiptsSettingsV1ReceiptsSettingsServiceUrl({
        protoPath: '/v1/receipts-settings',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'receiptsSettings.createdDate' },
              { path: 'receiptsSettings.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getReceiptsSettings;
}

/** Updates a site's receipt settings, or creates them if none exist. */
export function updateReceiptsSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __updateReceiptsSettings({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'receiptsSettings.createdDate' },
          { path: 'receiptsSettings.updatedDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.receipts.v1.receipts_settings',
      method: 'PATCH' as any,
      methodFqn:
        'wix.receipts.settings.v1.ReceiptsSettingsService.UpdateReceiptsSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixReceiptsSettingsV1ReceiptsSettingsServiceUrl({
        protoPath: '/v1/receipts-settings',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'receiptsSettings.createdDate' },
              { path: 'receiptsSettings.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateReceiptsSettings;
}
